export default __webpack_public_path__ + "static/media/theme7.4e29f376.png";